import React from 'react'
import { ActionIcon } from '@mantine/core'
import { IconBrandX } from '@tabler/icons-react'

/**
 * Renders the X link.
 * @param {string} url The X URL.
 * @param {string} color The text color for the button.
 * @returns {JSX.Element}
 */
function XIcon ({ url, color }) {
  return (
    <ActionIcon
      variant='filled'
      color={color}
      aria-label='X'
      size='sm'
      component='a'
      href={url}
      target='_blank'
      autoContrast
    >
      <IconBrandX stroke={2} aria-label='Follow on X' />
    </ActionIcon>
  )
}

export default React.memo(XIcon)
